// Only installed PWAs on Chrome/Edge have this; a plain browser tab silently does nothing.
export function applyAppBadge(count: number): void {
  if (!("setAppBadge" in navigator) || !("clearAppBadge" in navigator)) return;
  const badged = count > 0 ? navigator.setAppBadge(count) : navigator.clearAppBadge();
  void badged.catch(() => undefined);
}

export function clearAppBadge(): void {
  applyAppBadge(0);
}
